import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import SEO from '../components/SEO';

const Home = () => {
  const prefersReducedMotion = useReducedMotion();

  const marqueeAnimation = prefersReducedMotion
    ? { x: 0 }
    : {
        x: [-1000, 0],
        transition: {
          x: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: 25,
            ease: 'linear',
          },
        },
      };

  return (
    <>
      <SEO
        title="Broadway Muses"
        description="Broadway Muses — Broadway culture, stories, and conversations from New York City."
        path="/"
      />

      <section
        aria-labelledby="homepage-title"
        className="flex flex-grow flex-col justify-center overflow-hidden pb-20 pt-40"
      >
        <header className="relative z-10 flex justify-center px-6 text-center">
          <motion.div
            initial={prefersReducedMotion ? false : { opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={
              prefersReducedMotion ? { duration: 0 } : { duration: 1.2 }
            }
            className="w-full max-w-6xl border-x-8 border-black px-4 sm:px-8"
          >
            <h1
              id="homepage-title"
              className="mx-auto max-w-full break-words font-serif text-[clamp(2.75rem,12vw,14rem)] font-black uppercase italic leading-none tracking-[-0.06em] text-black"
            >
              Broadway Muses
            </h1>
            <p className="mx-auto mt-8 max-w-3xl font-mono text-xs font-black uppercase leading-loose tracking-[0.15em] sm:text-sm sm:tracking-[0.2em]">
              A SITE FOR THE RESTLESS, THE CURIOUS, AND EVERYONE STILL WAITING
              FOR THE HOUSE LIGHTS TO COME UP.
            </p>
          </motion.div>
        </header>

        <aside
          aria-label="Broadway Muses location and current status"
          className="mt-20 w-full overflow-hidden border-y-2 border-black bg-white py-4"
        >
          <p className="sr-only">
            New York City. Act 1 in preparation.
          </p>
          <motion.div
            aria-hidden="true"
            className="flex gap-10 whitespace-nowrap"
            animate={marqueeAnimation}
          >
            {[...Array(10)].map((_, index) => (
              <span
                key={index}
                className="font-mono text-xl font-black uppercase tracking-[0.3em] text-black md:text-3xl"
              >
                NEW YORK CITY • ACT 1 IN PREPARATION •
              </span>
            ))}
          </motion.div>
        </aside>
      </section>
    </>
  );
};

export default Home;